import Vue from 'vue';

import store from './store/'
import ElementUI from 'element-ui'
import './assets/css/style.scss'
import router from './router/'
import Config from './config/app'
import M from './utils/methods';

// import XLSX from "xlsx";

import * as socketApi from './socket';

import {
    isLogin,
    getToken
}
from './utils/dataStorage'
import {
    formatDate,
    numberFormat
} from './utils/index'

import { CountDown, Badge } from 'vant';

import App from './App.vue'

Vue.prototype.$Config = Config;

Vue.prototype.$socketApi = socketApi

Vue.use(ElementUI)
    // Vue.use(XLSX);
Vue.use(CountDown)
Vue.use(Badge)


router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title ? to.meta.title + '-' + Config.siteName : Config.siteName;

    if (!isLogin() && to.path != '/login') {
        next({
            path: '/login'
        });
    } else {
        next();
    }
});
router.afterEach(transition => {

});

Vue.filter("dateTime", function(v) {
    if (!v) return "-"
    var date = new Date(parseInt(v));
    return formatDate(date, "yyyy-MM-dd hh:mm:ss")
})
Vue.filter("amountRMB", function(v) {
    return "￥" + numberFormat(v, 2)
})
Vue.filter("amountUSDT", function(v) {
    return (v / 100).toFixed(2)
})

var _vue = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
socketApi.initSocket(_vue);